import type * as React from "react";
import styles from "./CaretToggle.module.scss";
import { CaretRightIcon } from "../../../assets/icons/CaretRightIcon";
import classNames from "classnames";

export const CaretToggle = ({
  expanded,
  className,
  onClick,
}: {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  expanded: boolean;
  className?: string;
}) => (
  <CaretRightIcon
    onClick={onClick}
    className={classNames(styles.caret, className, {
      [styles.expanded]: expanded,
    })}
  />
);
